import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.996 6.117A7.998 7.998 0 0 0 18 2a7.976 7.976 0 0 0-5.729 2.416A7.974 7.974 0 0 0 10 10c0 .783.113 1.54.323 2.258L3 19.585V25h5.414L11 22.414V20h2.414l2.327-2.324A8 8 0 0 0 25.834 8.37a7.503 7.503 0 0 1 5.163 7.347L28.5 13.719l-8.5 6.8v1.616a7.534 7.534 0 0 1-3.09-3.05l-1.47 1.445A9.533 9.533 0 0 0 20 24.334V37h17V20.52l-4.151-3.322c.099-.55.15-1.118.15-1.698 0-4.738-3.467-8.665-8.003-9.383ZM18 4a6 6 0 0 0-5.598 8.164l.235.608L5 20.414V23h2.586L9 21.586V18h3.586l2.641-2.638.607.236c.67.26 1.4.402 2.166.402a6 6 0 0 0 5.659-7.998 7.66 7.66 0 0 0-1.774.172 3 3 0 1 1-1.296-1.72 9.457 9.457 0 0 1 1.928-.404A5.986 5.986 0 0 0 18 4Zm4 20.882V35h13V21.48l-6.5-5.2-6.5 5.2v1.37a7.531 7.531 0 0 0 3.017-.004 3.5 3.5 0 1 1 .778 1.874 9.523 9.523 0 0 1-3.795.162ZM19 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm8 14.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const PictogramBuildingCommissioning40 = createIcon(IconComponent);